import Database from 'database';
import { Produto, Queue } from 'models';
import { Creators as reduxQueue } from './queue';
import api from 'api';
import { sortProducts } from 'shared/business';

export const Types = {
  GET_PRODUTOS: 'produtos/GET_PRODUTOS',
  GET_PRODUTOS_SUCCESS: 'produtos/GET_PRODUTOS_SUCCESS',
  GET_PRODUTOS_FAILED: 'produtos/GET_PRODUTOS_FAILED',
  ADD_PRODUTO: 'produtos/ADD_PRODUTO',
  ADD_PRODUTO_SUCCESS: 'produtos/ADD_PRODUTO_SUCCESS',
  ADD_PRODUTO_FAILED: 'produtos/ADD_PRODUTO_FAILED',
  DELETE_PRODUTO: 'produtos/DELETE_PRODUTO',
  DELETE_PRODUTO_SUCCESS: 'produtos/DELETE_PRODUTO_SUCCESS',
  DELETE_PRODUTO_FAILED: 'produtos/DELETE_PRODUTO_FAILED',
};

const initialState = {
  data: [],
  map: {},
  error: null,
  loading: false,
};

export default function produtosReducer(state = initialState, action) {
  switch (action.type) {
    case Types.GET_PRODUTOS:
      return { ...state, loading: true };
    case Types.GET_PRODUTOS_SUCCESS:
      return { loading: false, ...action.payload };
    case Types.GET_PRODUTOS_FAILED:
      return { ...state, loading: false, ...action.payload };
    case Types.DELETE_PRODUTO:
      return { ...state, loading: true };
    case Types.DELETE_PRODUTO_FAILED:
      return { ...state, loading: false, ...action.payload };
    case Types.DELETE_PRODUTO_SUCCESS:
      return { ...state, loading: false, ...action.payload };
    case Types.ADD_PRODUTO:
      return { ...state, loading: true, error: null };
    case Types.ADD_PRODUTO_FAILED:
      return { ...state, loading: false, ...action.payload };
    case Types.ADD_PRODUTO_SUCCESS:
      return { ...state, loading: false, error: null, ...action.payload };
    default:
      return state;
  }
}

export const Creators = {
  getProdutos: (condition) => async (dispatch) => {
    dispatch({ type: Types.GET_PRODUTOS });
    try {
      let produtos = await Database.produtos
        .filter(condition || (() => true))
        .toArray();
      for (let i = 0; i < produtos.length; i++) {
        const produto = produtos[i];
        produtos[i] = {
          ...produtos[i],
          id: produto.id || produto._id,
          N: Number(produto.NH2) + Number(produto.NH4) + Number(produto.NO3),
        };
      }
      produtos = sortProducts(produtos);
      dispatch({
        type: Types.GET_PRODUTOS_SUCCESS,
        payload: {
          data: produtos,
          map: produtos.reduce((r, p) => ({ ...r, [p.id]: p }), {}),
        },
      });
    } catch (oof) {
      console.error(oof.message);
      dispatch({
        type: Types.GET_PRODUTOS_FAILED,
        payload: { error: oof.message },
      });
    }
  },
  addProduto: (form, notJustAnEtec, id = null) => async (dispatch) => {
    dispatch({ type: Types.ADD_PRODUTO });
    try {
      // Find a product with same name and manufacturer
      const sameNameAndManufacturerProduct = (
        await Database.produtos.toArray()
      ).find(
        ({ nome, classificacao, user_id }) =>
          String(user_id) === String(form.user_id) &&
          String(nome).toLowerCase() === String(form.nome).toLowerCase() &&
          String(classificacao).toLowerCase() ===
            String(form.classificacao).toLowerCase(),
      );
      // If there is a product of same data
      if (sameNameAndManufacturerProduct) {
        // If It's editing and the product with same data is the same product
        if (
          id &&
          (sameNameAndManufacturerProduct.id
            ? id === sameNameAndManufacturerProduct.id
            : id === sameNameAndManufacturerProduct._id)
        ) {
          const localCurb = await Database.produtos.filter(
            ({ id: entityId, _id }) =>
              (!entityId && String(_id) === String(id)) ||
              String(id) === String(entityId),
          );
          await localCurb.delete();
        } else {
          dispatch({
            type: Types.ADD_PRODUTO_FAILED,
            payload: {
              error: 'duplicate entry',
              errorMessage: 'Já existe um produto de mesmo nome e marca',
            },
          });
          return;
        }
      } else if (id) {
        await (
          await Database.produtos.filter(
            (p) => p.id === id || (!p.id && p._id === id),
          )
        ).delete();
      }
      const pData = {
        ...form,
      };
      for (let i in pData) {
        if (!pData[i] && i !== 'user_id') {
          pData[i] = 0;
        }
        i++;
      }
      const produto = new Produto(pData);
      await produto.save();
      if (!id) {
        const queue = new Queue({
          table: 'produtos',
          localId: produto._id,
          requestBody: pData,
        });
        await queue.save();
        dispatch({ type: Types.ADD_PRODUTO_SUCCESS });
        dispatch(
          Creators.getProdutos(
            (x) => String(x.user_id) === String(form.user_id) || notJustAnEtec,
          ),
        );
        dispatch(reduxQueue.getQueue());
      } else {
        const queue = new Queue({
          url: `produtos/${id}`,
          table: 'produtos',
          localId: produto._id,
          requestBody: pData,
        });
        await queue.save();
        dispatch({ type: Types.ADD_PRODUTO_SUCCESS });
        dispatch(
          Creators.getProdutos(
            (x) => String(x.user_id) === String(form.user_id) || notJustAnEtec,
          ),
        );
        dispatch(reduxQueue.getQueue());
      }
    } catch (oof) {
      console.log(oof.message);
      dispatch({
        type: Types.ADD_PRODUTO_FAILED,
        payload: { error: (oof && oof.message) || 'Serviço indisponível' },
      });
    }
  },
  deleteProduto: (id) => async (dispatch, store) => {
    try {
      dispatch({ type: Types.DELETE_PRODUTO });
      await api.delete(`/produtos/${id}`);
      dispatch({
        type: Types.DELETE_PRODUTO_SUCCESS,
        payload: { data: store().produtos.data.filter((p) => p.id !== id) },
      });
    } catch (e) {
      dispatch({
        type: Types.DELETE_PRODUTO_FAILED,
        payload: { error: e.message },
      });
    }
  },
};
